import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtiltityService } from './services/Utility.service';
import { PubnubService } from './services/Pubnub.service';

declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'cesiumapp';

  constructor(private utility: UtiltityService, private pubnub: PubnubService) {

  }

  ngOnInit() {}
}
